import { render, staticRenderFns } from "./ItqTenderTNC.vue?vue&type=template&id=0496b01c&scoped=true&"
import script from "./ItqTenderTNC.vue?vue&type=script&lang=js&"
export * from "./ItqTenderTNC.vue?vue&type=script&lang=js&"
import style0 from "./ItqTenderTNC.vue?vue&type=style&index=0&id=0496b01c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0496b01c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0496b01c')) {
      api.createRecord('0496b01c', component.options)
    } else {
      api.reload('0496b01c', component.options)
    }
    module.hot.accept("./ItqTenderTNC.vue?vue&type=template&id=0496b01c&scoped=true&", function () {
      api.rerender('0496b01c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/settings/engineers/regionConfig/ItqTenderTNC.vue"
export default component.exports